import { EditorContent } from '@tiptap/react';

import { Box } from '@mui/material';

import { EditorMenu } from './menu/EditorMenu';
import type { RootOwner } from './menu/anchor-button/file-selector/FileSelectorDialog';
import type { UseOr2EditorProps } from './hooks/useOr2Editor';
import { useOr2Editor } from './hooks/useOr2Editor';
import { Or2BubbleMenu } from './bubble-menu/Or2BubbleMenu';

type ConditionalProps =
  | {
      rootOwner: RootOwner;
      editable: true;
      disableFileSelector?: boolean;
      disableMenu?: boolean;
    }
  | {
      rootOwner?: RootOwner | never;
      editable: true;
      disableFileSelector: true;
      disableMenu?: boolean;
    }
  | {
      rootOwner?: RootOwner | never;
      editable?: boolean | never;
      disableFileSelector?: never;
      disableMenu?: never;
    };

type Props = UseOr2EditorProps &
  ConditionalProps & {
    stickyMenu?: boolean;
  };

const TableWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      '& .ProseMirror table': {
        marginTop: 2,
        width: '100%',
        borderCollapse: 'collapse',
      },

      '& .ProseMirror th, .ProseMirror td': {
        border: '1px solid black',
        padding: 1,
        textAlign: 'left',
      },
      '& .ProseMirror th': {
        backgroundColor: '#f2f2f2',
      },
    }}
  >
    {children}
  </Box>
);

export const Editor = ({
  editable = false,
  disableFileSelector = false,
  disableMenu = false,
  stickyMenu = false,
  rootOwner,
  ...other
}: Props) => {
  const editor = useOr2Editor({
    editable,
    ...other,
  });

  return (
    <TableWrapper>
      {editable && (
        <Or2BubbleMenu
          editor={editor}
          rootOwner={rootOwner}
          disableFileSelector={disableFileSelector}
        />
      )}
      <EditorContent editor={editor} />
      {editable && !disableMenu && (
        <EditorMenu
          editor={editor}
          rootOwner={rootOwner}
          disableFileSelector={disableFileSelector}
          sticky={stickyMenu}
        />
      )}
    </TableWrapper>
  );
};
